import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { ArrowRight, ChevronRight, ChevronsRight } from "react-feather";
import { BANNER_BG, PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
const AboutUs = () => {
  const items = [
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/BIA- Award photo.png"
      alt=""
      onClick={() => window.open("/img/Award/BIA- Award photo.png")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/receiving photo.png"
      alt=""
      onClick={() => window.open("/assets/img/Award/receiving photo.png")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/brand icon award.jpg"
      alt=""
      onClick={() => window.open("/assets/img/Award/brand icon award.jpg")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/brand icon.jpg"
      alt=""
      onClick={() => window.open("/assets/img/Award/brand icon.jpg")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/award.jpeg"
      alt=""
      onClick={() => window.open("/assets/img/Award/award.jpeg")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/Glory Award.png"
      alt=""
      onClick={() => window.open("/assets/img/Award/Glory Award.png")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/Glory Award receiving.png"
      alt=""
      onClick={() => window.open("/assets/img/Award/Glory Award receiving.png")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/award44.jpeg"
      alt=""
      onClick={() => window.open("/assets/img/Award/award44.jpeg")}
      role="presentation"
    />,
    <img
      style={{ width: "100%", padding: "0 6px", height: "280px" }}
      src="/assets/img/Award/Times Business Award Image Final.jpg"
      alt=""
      onClick={() =>
        window.open("/assets/img/Award/Times Business Award Image Final.jpg")
      }
      role="presentation"
    />,
  ];
  const responsive = {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1024: {
      items: 3,
      itemsFit: "contain",
    },
  };

  return (
    <div className="">
      <header
        id="home"
        className="hero-area"
        style={{ backgroundColor: BANNER_BG }}
      >
        <div className="container">
          <div className="row space-100">
            <div className="col-lg-7 col-md-12 col-xs-12">
              <div className="contents text-dark">
                <h1
                  // className="head-title"
                  className="display-6 fw-bold mb-3"
                  style={{ color: PRIMARY_COLOR }}
                  // style={{ fontSize: "55px", lineHeight: "4rem" }}
                >
                  Why Us? <br />
                </h1>
                <h5>
                  <ChevronsRight /> Field Audits
                </h5>

                <h5>
                  <ChevronsRight /> Part time job
                </h5>

                <h5>
                  <ChevronsRight /> Flexiblity
                </h5>

                <h5>
                  <ChevronsRight /> Utilise your Weekends
                </h5>

                <h5>
                  <ChevronsRight /> Jobs for Freelancers
                </h5>

                <h5>
                  <ChevronsRight /> Earn while you study
                </h5>

                <h5>
                  <ChevronsRight /> Help your friend with{" "}
                  <span style={{ color: PRIMARY_COLOR }}>
                    Refer & Earn program
                  </span>
                </h5>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-xs-12">
              <div className="intro-img">
                <img src="/assets/img/rb_9814.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="container mt-5">
        <div>
          <div class="row">
            <div class="col-md-8 col-sm-8 col-12">
              <div class="pr-30-md">
                <div class="section-heading center-holder">
                  <p
                    className="my-3 headingStyle"
                    style={{ fontSize: "1.7rem" }}
                  >
                    BetelJobs
                  </p>
                  <div class="section-heading-line"></div>
                </div>
                <div class="section-heading-line-left"></div>
                <div class="text-content-big mt-20">
                  <p style={{ color: PRIMARY_TEXT_COLOR }}>
                    Welcome to BetelJobs, your go-to platform for field audit
                    opportunities. We are dedicated to empowering job seekers by
                    creating a seamless, user-friendly environment that bridges
                    the gap between ambition & success and provide opportunities
                    at your doorstep. Whether you’re a pursuing your bachelors
                    or masters or a freelancer or retired or housewife or
                    someone exploring a new career path, we’re here to help you
                    find the perfect part-time or full time role in field
                    audits.
                    <br />
                    <strong>Our Mission</strong> <br/>
                   is to provide a dedicated portal for field
                    audits with wide geographical coverage across the globe. We
                    aim to simplify the part-time job search by offering a
                    reliable, user-friendly platform where opportunity meets
                    flexibility.
                  </p>
                </div>
              </div>
            </div>
            <div
              class="col-md-4 col-sm-4 col-12 bg-light mb-1"
              style={{ margin: "auto", paddingTop: "3rem" }}
            >
              {/* <img
                src="img/content/home5.jpg"
                class="rounded-border shadow-primary mt-15-xs"
                alt="img"
              /> */}
              {/* <div className="position-relative d-inline-block"> */}
              <img
                src={"/assets/img/rb_665.png"}
                alt="Community rewards"
                className="img-fluid "
              />
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-4 col-sm-4 col-12 bg-light"
              style={{ margin: "auto", paddingTop: "3rem" }}
            >
              <img
                src={"/assets/img/rb_9814.png"}
                alt="Community rewards"
                className="img-fluid "
              />
            </div>
            <div class="col-md-8 col-sm-8 col-12 my-5">
              <div class="pr-30-md">
                <div class="section-heading-line-left"></div>
                <div class="text-content-big mt-20">
                  <p style={{ color: PRIMARY_TEXT_COLOR}}>
                <strong> Who We Are</strong> 
                  <br />
                    Founded by a team of passionate professionals, BetelJobs is
                    a product of well-established consulting company TRPW
                    Strategic Partners based in India & USA supporting
                    entrepreneurs and senior executives across wide variety of
                    industries and business projects. BetelJobs is built on the
                    belief that everyone deserves the chance to pursue their
                    dream career and right to earn more. others.
                    <br />
                    <br />
                 <strong>Why BetelJobs</strong>   
                    <br />
                    Join Us to discover how BetelJobs can help you achieve your
                    goals and earn more in your own city or town. Browse
                    opportunities for field audits today. Together, we can build
                    a future with freedom and flexibility in your own way.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <div class="row">
            <div class="col-md-8 col-sm-8 col-12">
              <div class="pr-30-md">
                <div class="section-heading center-holder">
                  <p
                    className="my-3 headingStyle"
                    style={{ fontSize: "1.7rem" }}
                  >
                    TRPW Strategic Partners Pvt. Ltd
                  </p>
                  <div class="section-heading-line"></div>
                </div>
                <div class="section-heading-line-left"></div>
                <div class="text-content-big mt-20">
                  <p style={{ color: PRIMARY_TEXT_COLOR }}>
                    TRPW Strategic Partners Pvt. Ltd is a dynamic team consisting of
                    experienced finance and business professionals who have
                    corporate and consulting experiences, each spanning more
                    than a decade. We excel at creating business planning and
                    structuring solutions customized to your business and
                    objectives.
                    <br />
                    <br />
                    We are a boutique consulting firm based in Delhi- NCR, India
                    & USA supporting entrepreneurs and senior executives across
                    wide variety of industries and business projects. We provide
                    customized business and strategic solutions through our
                    industry experts for business structure modelling; long-term
                    or short-term business plans and finance strategy,
                    supporting in business expansion; assistance in CFO office
                    functions, its implementation and compliances; transaction
                    process outsourcing, internal & process audits amongst
                    others. We want you to focus on what you do best, leave rest
                    to us.
                    <br />
                  </p>
                </div>
              </div>
            </div>
            <div
              class="col-md-4 col-sm-4 col-12"
              style={{ margin: "auto", paddingTop: "3rem" }}
            >
              {/* <img
                src="img/content/home5.jpg"
                class="rounded-border shadow-primary mt-15-xs"
                alt="img"
              /> */}
              {/* <div className="position-relative d-inline-block"> */}
              <img
                src={"/assets/img/success.jpg"}
                alt="Community rewards"
                className="img-fluid "
              />
            </div>
          </div>
        </div>
        <div className="mt-5">
          <div class="section-heading center-holder  ">
            <p
              className="mb-4 text-center pt-5 "
              style={{ fontSize: "1.7rem", color: "#000" }}
            >
              Awards & Recognitions
            </p>
            <div class="section-heading-line"></div>
          </div>
          <AliceCarousel
            responsive={responsive}
            autoPlay
            mouseTracking
            autoPlayInterval={1000}
            animationDuration={1000}
            animationType="fadeout"
            infinite
            // disableButtonsControls
            items={items}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
